import { Api } from '@/api'

const state = {
  fieldListMap: {},
  fieldLimitListMap: {} // 权限字段返回
}
const mutations = {
  setListMap: (state, val) => {
    const obj = {}
    val.forEach((item) => {
      obj[item.instanceCode] = item
    })
    state.fieldListMap = {
      ...state.fieldListMap,
      ...obj
    }
  },
  setLimitListMap: (state, val) => {
    if (val && val.length === 0) {
      state.fieldLimitListMap = {}
    } else {
      const obj = {}
      val.forEach((item) => {
        obj[item.instanceCode] = item
      })
      state.fieldLimitListMap = obj
    }
  }
}
// 获取布局权限配置
const actions = {
  async setLimitListMapAction({ commit }, payload) {
    const { data, config } = payload
    let dataObj = {}
    try {
      dataObj = JSON.parse(config)
    } catch (err) {
      dataObj = {}
    }
    try {
      const res = await Api.getAllFieldsByView({ layoutConfigId: data.layoutConfigId, objectCode: dataObj.objectCode, layoutPageType: dataObj.layoutPageType })
      if (res.code === '0' && res.data && res.data.length) {
        commit('setLimitListMap', res.data)
      }
    } catch (err) {
      commit('setLimitListMap', [])
    }
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}

